import { Helmet } from 'react-helmet-async';

export default function HelmetMeta({title}) {
    return (
        <Helmet>
            <title>{`${title} | Cayenne POS`}</title>
        </Helmet>
    );
}
